"use client";
import { useEffect, useRef, useState } from "react";
import { useLocale } from "./LocaleProvider";

const copy = {
  en: {
    title: "Behind the Scenes: Doctors testimonials",
    prev: "Previous",
    next: "Next",
    goTo: "Go to video",
    testimonial: "Testimonial",
  },
  ro: {
    title: "În culise: mărturii ale medicilor",
    prev: "Anterior",
    next: "Următor",
    goTo: "Mergi la videoclipul",
    testimonial: "Mărturie",
  },
} as const;

type VideoItem = {
  src: string;
  title: string;
};

const VIDEOS: VideoItem[] = [
  { src: "https://www.youtube.com/embed/TcZc9is2OTU?rel=0&modestbranding=1", title: "Testimonial 2" },
  { src: "https://www.youtube.com/embed/GqwLrHlSgTc?rel=0&modestbranding=1", title: "Testimonial 3" },
  { src: "https://www.youtube.com/embed/ZSryGdxHspU?rel=0&modestbranding=1", title: "Testimonial 4" },
];

export default function TestimonialsCarousel() {
  const t = copy[useLocale()];
  const [index, setIndex] = useState(0);

  const prev = () => setIndex((i) => (i - 1 + VIDEOS.length) % VIDEOS.length);
  const next = () => setIndex((i) => (i + 1) % VIDEOS.length);

  // navigare tastatură
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // swipe mobil
  const startX = useRef<number | null>(null);
  const onTouchStart = (e: React.TouchEvent) => (startX.current = e.touches[0].clientX);
  const onTouchEnd = (e: React.TouchEvent) => {
    if (startX.current === null) return;
    const delta = e.changedTouches[0].clientX - startX.current;
    if (Math.abs(delta) > 40) (delta > 0 ? prev() : next());
    startX.current = null;
  };

  const video = VIDEOS[index];

  return (
    <section className="container-px mx-auto py-12">
      <h2 className="text-center text-2xl md:text-3xl font-semibold text-white mb-6">
        {t.title}
      </h2>

      <div
        className="relative mx-auto max-w-5xl"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        {/* Video Card */}
        <div className="rounded-2xl border border-[#27E8A7] bg-black/30 backdrop-blur-sm shadow-[0_0_14px_rgba(39,232,167,0.25)] overflow-hidden aspect-video">
          <iframe
            key={video.src}
            width="100%"
            height="100%"
            src={video.src}
            title={video.title.replace("Testimonial", t.testimonial)}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        {/* Săgeți */}
        <button
          aria-label={t.prev}
          onClick={prev}
          className="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/60 border border-white/15 text-white hover:bg-black/80 transition grid place-items-center"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>

        <button
          aria-label={t.next}
          onClick={next}
          className="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/60 border border-white/15 text-white hover:bg-black/80 transition grid place-items-center"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>

        {/* Dots */}
        <div className="mt-4 flex justify-center gap-2">
          {VIDEOS.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`${t.goTo} ${i + 1}`}
              className={`h-2.5 w-2.5 rounded-full transition ${
                i === index ? "bg-white" : "bg-white/30 hover:bg-white/60"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
